
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { useDispatch, useSelector  } from 'react-redux';

import {
    IfComp,
    PanelSectionTitle
} from '../../../core';

import {
    getDataProjectId,
    useToken
} from '../../../project';

import { getActions } from '../../sagas';
import { getDocument } from '../../reducers';

import {
    getDocumentList,
    isLoading
} from '../../reducers/document'

import DocumentList from './DocumentList';

const DocumentPanel = ({objectKey, readOnly}) => {

    const classNames = mergeStyleSets({
        DocumentPanel: {
        },
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const token = useToken();

    const projectId = useSelector(state => getDataProjectId(state.project));

    const documentList = useSelector(state => getDocumentList(getDocument(state.data), objectKey));
    const loading = useSelector(state => isLoading(getDocument(state.data)));

    React.useEffect(() => {
        if (!documentList && !loading) {
            dataActions.getDocumentList(token, projectId, objectKey, {});
        }
    }, [objectKey]);

    const visible = (!documentList || (documentList && ((documentList.length > 0) || (!readOnly))));

    return (
        <IfComp cond={visible}>
            <Stack verticalFill className={classNames.ObjectInfoNo} tokens={{childrenGap: 4}}>
                <PanelSectionTitle title="Připojené odkazy na dokumenty" />
                <IfComp cond={(!documentList && loading)}>
                    Načítám odkazy na dokumenty...
                </IfComp>
                <IfComp cond={documentList}>
                    <DocumentList
                        dataActions={dataActions}
                        documentList={documentList}
                        objectKey={objectKey}
                        projectId={projectId}
                        readOnly={readOnly}
                        token={token}
                    />
                </IfComp>
            </Stack>
        </IfComp>
    );
}

export default DocumentPanel;
